(() => {
  const config = document.getElementById('codex-combo-guard-config');
  if (!config) return;
  const settings = JSON.parse(config.textContent);
  const permitted = new WeakSet();
  let checking = false;
  let dialog;
  const show = (content) => {
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.style.cssText = 'position:fixed;inset:0;margin:auto;max-width:560px;width:calc(100% - 32px);max-height:85vh;overflow:auto;padding:24px;border:1px solid #ddd;border-radius:16px;background:white;color:#111;z-index:2147483647;box-shadow:0 12px 60px #0006';
      document.body.append(dialog);
    }
    dialog.replaceChildren();
    const title = document.createElement('h2');
    title.textContent = settings.title;
    title.style.cssText = 'font-size:22px;margin-bottom:16px';
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = settings.close;
    close.style.cssText = 'padding:12px 20px;background:#111;color:white;border-radius:8px;margin-top:20px';
    close.onclick = () => dialog.close();
    dialog.append(title, content, close);
    dialog.querySelectorAll('a').forEach(link => { link.style.cssText = 'display:block;text-decoration:underline;margin:12px 0'; });
    if (!dialog.open) dialog.showModal();
  };
  const checkoutControl = event => event.composedPath().find(node => {
    if (!(node instanceof Element)) return false;
    if (node.matches('[name="checkout"], [data-combo-checkout], .shopify-payment-button__button, shopify-accelerated-checkout-cart')) return true;
    if (node.matches('a[href]') && /\/checkout(?:s)?(?:\/|\?|$)/.test(node.getAttribute('href'))) return true;
    return node.matches('button, [role="button"]') && /checkout|check.out|finalizar compra|finalizar pedido|proceder al pago|passer à la caisse|zur kasse|ödeme/i.test(node.textContent);
  });
  const check = async (event, control, form) => {
    if (permitted.has(control) || (form && permitted.has(form))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      const response = await fetch(settings.root + '?section_id=codex-combo-cart-check', {cache:'no-store', credentials:'same-origin', signal:AbortSignal.timeout(10000)});
      if (!response.ok) throw new Error('Cart validation unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = doc.querySelector('[data-combo-cart-check]');
      if (!result) throw new Error('Cart validation missing');
      if (result.querySelector('[data-incomplete-combo]')) { show(result); return; }
      permitted.add(control);
      if (form) permitted.add(form);
      try {
        if (event.type === 'submit') form.requestSubmit(event.submitter || undefined);
        else control.click();
      } finally {
        permitted.delete(control);
        if (form) permitted.delete(form);
      }
    } catch (_) {
      const message = document.createElement('p');
      message.textContent = settings.retry;
      show(message);
    } finally { checking = false; }
  };
  window.addEventListener('click', event => {
    const control = checkoutControl(event);
    if (control) check(event, control, control.form);
  }, true);
  window.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout' || /\/checkout(?:\/|\?|$)/.test(event.target.action || '')) check(event, event.submitter || event.target, event.target);
  }, true);
})();
